export enum CHURCH_ADMIN_ACCESS_PRODUCT {
  MPA = 'mpa',
  MESSAGES = 'messages',
  CAMINO = 'camino',
  FORMS = 'forms',
}

export const CHURCH_ADMIN_ACCESS_PRODUCT_LABELS: Record<CHURCH_ADMIN_ACCESS_PRODUCT, string> = {
  [CHURCH_ADMIN_ACCESS_PRODUCT.MPA]: 'MyParish (MPA)',
  [CHURCH_ADMIN_ACCESS_PRODUCT.MESSAGES]: 'Messages',
  [CHURCH_ADMIN_ACCESS_PRODUCT.CAMINO]: 'Camino',
  [CHURCH_ADMIN_ACCESS_PRODUCT.FORMS]: 'Forms',
};

export type ChurchAdminAccessChurch = {
  id: string;
  name: string;
  zipCode: string;
  programs: string[];
};

export type ChurchAdminAccessItem = {
  userId: string;
  ssoUserId: string;
  email: string;
  firstName: string;
  lastName: string;
  churches: ChurchAdminAccessChurch[];
};

export type ChurchAdminAccessListParams = {
  term?: string;
  limit?: number;
  cursor?: string;
};

export type ChurchAdminAccessListResponse = {
  items: ChurchAdminAccessItem[];
  limit: number;
  total?: number;
};

export type GrantChurchAdminAccessPayload = {
  products: CHURCH_ADMIN_ACCESS_PRODUCT[];
};

export type InitTempChurchAdminAccessPayload = {
  churchId: string;
  programs: CHURCH_ADMIN_ACCESS_PRODUCT[];
};

export type InitTempChurchAdminAccessResponse = {
  email: string;
};
